<h1 class="page-title mb-5">معرض الفيديو</h1>
<div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-9">
        <div class="video-grid">
          <div class="video-card mb-5" *ngFor="let video of videos" (click)="openVideo(video.id)">
            <div class="video-thumbnail-wrapper">
              <div class="green-decoration"></div>
              <img [src]="video.thumbnail" [alt]="video.title" class="video-thumbnail"
                onerror="this.src='assets/images/placeholder.jpg'" />
              <div class="play-overlay">
                <i class="material-icons">play_arrow</i>
              </div>
            </div>
            <h3 class="video-title">{{ video.title }}</h3>
          </div>
        </div>

        <!-- Video Modal -->
        <div class="video-modal-overlay" *ngIf="isModalOpen" (click)="closeModal()">
          <div class="video-modal-content" (click)="$event.stopPropagation()">
            <button class="close-btn" (click)="closeModal()">
              <i class="material-icons">close</i>
            </button>
            <div class="iframe-container" *ngIf="selectedVideoUrl">
              <iframe [src]="selectedVideoUrl" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen>
              </iframe>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <app-fix-media></app-fix-media>
      </div>
    </div>
  </div>
</div>